import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TrademarkRegistration from './pages/TrademarkRegistration';
import CopyrightRegistration from './pages/CopyrightRegistration';
import CompanyFormation from './pages/CompanyFormation';
import AmazonBrandRegistry from './pages/AmazonBrandRegistry';
import TrademarkSearch from './pages/TrademarkSearch';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import { Toaster } from './components/ui/toaster';

function AppContent() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const isLandingPage = location.pathname === '/lp';

  return (
    <div className="App">
      {!isLandingPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lp" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/trademark-registration" element={<TrademarkRegistration />} />
        <Route path="/copyright-registration" element={<CopyrightRegistration />} />
        <Route path="/company-formation" element={<CompanyFormation />} />
        <Route path="/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        <Route path="/trademark-search" element={<TrademarkSearch />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
      </Routes>
      {!isLandingPage && <Footer />}
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;